__turbopack_context__.v({
  "body": "innovation-investor-module-scss-module__6-Capa__body",
  "container": "innovation-investor-module-scss-module__6-Capa__container",
  "divider": "innovation-investor-module-scss-module__6-Capa__divider",
  "eyebrow": "innovation-investor-module-scss-module__6-Capa__eyebrow",
  "grid": "innovation-investor-module-scss-module__6-Capa__grid",
  "heading": "innovation-investor-module-scss-module__6-Capa__heading",
  "learnMore": "innovation-investor-module-scss-module__6-Capa__learnMore",
  "left": "innovation-investor-module-scss-module__6-Capa__left",
  "right": "innovation-investor-module-scss-module__6-Capa__right",
  "row": "innovation-investor-module-scss-module__6-Capa__row",
  "rowArrow": "innovation-investor-module-scss-module__6-Capa__rowArrow",
  "rowBody": "innovation-investor-module-scss-module__6-Capa__rowBody",
  "rowFigure": "innovation-investor-module-scss-module__6-Capa__rowFigure",
  "rowSub": "innovation-investor-module-scss-module__6-Capa__rowSub",
  "rowTag": "innovation-investor-module-scss-module__6-Capa__rowTag",
  "rowTitle": "innovation-investor-module-scss-module__6-Capa__rowTitle",
  "rowsHead": "innovation-investor-module-scss-module__6-Capa__rowsHead",
  "section": "innovation-investor-module-scss-module__6-Capa__section",
});
